export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SEEN_HCP = 'SEEN_HCP';
export const SEEN_ISI = 'SEEN_ISI';
export const LOGIN_ERROR = 'LOGIN_ERROR';
